import { createStore } from "vuex";

export default createStore({
  state: {
    loginUser: {},
  },
  mutations: {
    setLoginUser(state, data) {
      state.loginUser = data;
    },
  },
  actions: {},
  modules: {},
});
